export default function StepDescription() {
  return (
    <div>
      <div className="mt-20 font-bold font-inter text-24px leading-29px">
        The steps in practice
      </div>
      <div className="mr-45 font-inter text-base">
        <div className="mt-8">
          Now that we know the steps we need to take to have timePhasing process our data, lets put our knowledge into practice!
        </div>
        <div className="mt-4">
          Below is an interactive demo that takes you through the four steps. Start of by selecting the type of input data that suits your needs in step 1. Every ensuing step allows you to experiment with the data and the various timePhasing functions on offer.
        </div>
        <div className="mt-4">
          To see what your data and choices look like in JSON format, try the view mode option.
        </div>
      </div>
    </div>
  )
}